import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
  baseLine: number
}

export type Attrs = Options

export class RVOLConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Rvol
  static abbreviation = 'rvol'
  static label = 'Relative Volume'
  static shortLabel = 'RVOL'
  static optionsOrder = ['period', 'baseLine'] as const
  static optionsLabels = { period: 'Period', baseLine: 'BaseLine' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
  static calculatedValuesOrder = ['rvol'] as const
  static calculatedValuesLabels = { rvol: 'RVOL' }
  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
